import React, { useEffect, useState } from 'react';
import './TroutAnimation.css';

const TroutAnimation = () => {
  const [scrollDepth, setScrollDepth] = useState(0);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.scrollY;
          const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
          const depth = Math.min(scrolled / maxScroll, 1);
          setScrollDepth(depth);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  // Determine visibility for trout (10-80%) and mahi (15-80%)
  const troutVisible = scrollDepth >= 0.1 && scrollDepth <= 0.8;
  const mahiVisible = scrollDepth >= 0.15 && scrollDepth <= 0.8;

  // Calculate individual opacities
  const troutOpacity = troutVisible ? Math.max(0.3, Math.min(
    (scrollDepth - 0.1) * 5, // Fade in
    (0.8 - scrollDepth) * 5   // Fade out
  )) : 0;
  
  const mahiOpacity = mahiVisible ? Math.max(0.3, Math.min(
    (scrollDepth - 0.15) * 5, // Fade in  
    (0.8 - scrollDepth) * 5   // Fade out
  )) : 0;

  if (!troutVisible && !mahiVisible) {
    return null;
  }

  return (
    <>
      {/* Trout container */}
      {troutVisible && (
        <div className="trout-animation-container" style={{ opacity: troutOpacity }}>
          <div className="animated-trout trout-1">
            <img src="/trout.gif" alt="" />
          </div>
          <div className="animated-trout trout-2">
            <img src="/trout.gif" alt="" />
          </div>
        </div>
      )}
      
      {/* Mahi container */}
      {mahiVisible && (
        <div className="trout-animation-container" style={{ opacity: mahiOpacity }}>
          <div className="animated-mahi mahi-1">
            <img src="/mahi.gif" alt="" />
          </div>
          <div className="animated-mahi mahi-left">
            <img src="/mahi.gif" alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default TroutAnimation;